import { Card, CardContent, Typography, LinearProgress, Box, Chip } from "@mui/material";

const ProdSubscriptionCard = ({ data, colors, daysLeft, totalDays }) => {
    // Progress (how much consumed)
   
    const consumedPercent = Math.min(100 - Math.round((daysLeft / totalDays) * 100), 100);

    // Plan Badge Color
    const planColors = {
        Gold: "#FFB300",
        Silver: "#B0BEC5",
        Platinum: "#E5E4E2",
        Basic: colors.blueAccent[400],
    };

    return (
        <Card
            sx={{
                borderRadius: 2,
                boxShadow: 3,
                height: "100%",
                backgroundColor: colors.primary[400],
                color: colors.grey[100],
                p: 1.5,
            }}
        >
            <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                    Subscription Details
                </Typography>

                {/* Plan Badge */}
                <Chip
                    label={data.subscription.plan}
                    sx={{
                        mb: 2,
                        fontWeight: 700,
                        backgroundColor: planColors[data.subscription.plan] || colors.greenAccent[500],
                        color: "#000",
                    }}
                />

                {/* Expiry Date */}
                <Typography variant="body1" sx={{ mb: 0.5 }}>
                    Expiry Date:
                    <strong> {data.subscription.expiry_date}</strong>
                </Typography>

                {/* Days Left */}
                <Typography variant="body1" sx={{ mb: 1 }}>
                    Days Left:
                    <strong> {daysLeft} days</strong>
                </Typography>

                {/* Progress Bar */}
                <Box sx={{ mt: 2 }}>
                    <Typography variant="caption" sx={{ mb: 0.5, display: "block" }}>
                        Usage Progress: {consumedPercent}%
                    </Typography>

                    <LinearProgress
                        variant="determinate"
                        value={consumedPercent}
                        sx={{
                            height: 10,
                            borderRadius: 5,
                            backgroundColor: colors.grey[700],
                            "& .MuiLinearProgress-bar": {
                                backgroundColor:
                                    planColors[data.subscription.plan] || colors.greenAccent[500],
                            },
                        }}
                    />
                </Box>
            </CardContent>
        </Card>
    );
};

export default ProdSubscriptionCard;
